/**
 * Javascript specific to tabs
 */

(function (window, document, $) {
    'use strict';

    var scoped = $('.c-tabs');

    $(scoped).find('.c-tabs__tab').click(function() {

        var index = $(this).index();
        var $tabsInstance = $(this).closest('.c-tabs');
        var $tabsInstanceTabs = $tabsInstance.find('.c-tabs__tab');
        var $tabsInstanceContents = $tabsInstance.find('.c-tabs__content');
        var $tabsInstanceTabWillBeActive = $tabsInstanceTabs.eq(index);
        var $tabsInstanceContentWillBeActive = $tabsInstanceContents.eq(index);


        $tabsInstanceTabs.not( $tabsInstanceTabWillBeActive ).removeClass('c-tabs__tab--active');
        $tabsInstanceContents.not( $tabsInstanceContentWillBeActive ).removeClass('c-tabs__content--active');

        $tabsInstanceTabWillBeActive.addClass('c-tabs__tab--active');
        $tabsInstanceContentWillBeActive.addClass('c-tabs__content--active');

    });

})( window, document, jQuery );
